import { 
  AutoStories as PracticeIcon,
  Spellcheck as ReadabilityIcon,
  CollectionsBookmark as CollectionsIcon,
  Timeline as PathwayIcon
  // Dashboard as DashboardIcon,
  // QueuePlayNext as RequestsIcon
} from '@mui/icons-material';

// Constants
export const DRAWER_WIDTH = 240;

export const MENU_ITEMS = [
  // { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
  { text: 'Practice', icon: <PracticeIcon />, path: '/' },
  { text: 'Collections', icon: <CollectionsIcon />, path: '/practice-collections' },
  { text: 'Pathways', icon: <PathwayIcon />, path: '/practice-pathways' },
  // { text: 'Requests', icon: <RequestsIcon />, path: '/requests' },
  { text: 'Readability', icon: <ReadabilityIcon />, path: '/readability' },
];